import styled from '@emotion/styled';

export const To = styled.h3`
  text-transform: none !important;
  display: block !important;
  // cursive needs more spacing
  margin: 16px 0 !important;
  font-size: 20px !important;
  line-height: 1 !important;
`;

export const CustomDateMessage = styled.h3`
  margin: 24px 0 !important;
`;

export const RangeDate = styled.div<{ variant?: 'start' | 'end' }>`
  h3 {
    margin: 0;
  }
  border: none !important;
  ${({ variant }) => variant === 'end' && `padding-top: 0 !important; margin-top: 0 !important`}
  ${({ variant }) =>
    variant === 'start' && `padding-bottom: 0 !important; margin-bottom: 0 !important;`}
`;
